
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class PickUpGrid extends Serenity.EntityGrid<PickUpRow, any> {
        protected getColumnsKey() { return 'ECommerce.PickUp'; }
        protected getDialogType() { return PickUpDialog; }
        protected getIdProperty() { return PickUpRow.idProperty; }
        protected getInsertPermission() { return PickUpRow.insertPermission; }
        protected getLocalTextPrefix() { return PickUpRow.localTextPrefix; }
        protected getService() { return PickUpService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {            
            var item = this.itemAt(row);
           // OrderItemsEditor.baseitemcheck = item.BaseItemTypeId;
            super.onClick(e, row, cell);            
        }
        protected addButtonClick() {
            
            let now = new Date();

            var voucher = FormatHelper.GetVoucherNo(80);
             
            this.editItem(<PickUpRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 80,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                TransDate: now.toDateString()                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

         



        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}